(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('race-question', {
            parent: 'entity',
            url: '/race-question',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.raceQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race-question/race-questions.html',
                    controller: 'RaceQuestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('raceQuestion');
                    $translatePartialLoader.addPart('raceQuestionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('race-question-detail', {
            parent: 'race-question',
            url: '/race-question/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.raceQuestion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race-question/race-question-detail.html',
                    controller: 'RaceQuestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('raceQuestion');
                    $translatePartialLoader.addPart('raceQuestionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RaceQuestion', function($stateParams, RaceQuestion) {
                    return RaceQuestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'race-question',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('race-question-detail.edit', {
            parent: 'race-question-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-question/race-question-dialog.html',
                    controller: 'RaceQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RaceQuestion', function(RaceQuestion) {
                            return RaceQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race-question.new', {
            parent: 'race-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-question/race-question-dialog.html',
                    controller: 'RaceQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                question: null,
                                raceQuestionType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('race-question', null, { reload: 'race-question' });
                }, function() {
                    $state.go('race-question');
                });
            }]
        })
        .state('race-question.edit', {
            parent: 'race-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-question/race-question-dialog.html',
                    controller: 'RaceQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RaceQuestion', function(RaceQuestion) {
                            return RaceQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race-question', null, { reload: 'race-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race-question.delete', {
            parent: 'race-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-question/race-question-delete-dialog.html',
                    controller: 'RaceQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RaceQuestion', function(RaceQuestion) {
                            return RaceQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race-question', null, { reload: 'race-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
